export default {
  root: {
    textTransform: "none"
  }
};
